import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DetailViewComponent } from '../../detail-view.component';

// text,email,tel,textarea,password,
@Component({
    selector: 'full-divider',
    templateUrl: './full-divider.component.html',
    styleUrls: ['./full-divider.component.scss'],
    standalone: false
})
export class FullDividerComponent implements OnInit, OnDestroy {
  @Input() prop: any = {};
  @Input() viewExpanded: boolean;

  constructor(public detailViewComponent: DetailViewComponent) {}

  ngOnInit() {}

  ngOnDestroy() {}
}
